exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-switch__label *{font-size:18px;font-weight:700}.el-switch__label.is-active{color:#fc3317}", ""]);

// exports
